import styled from 'vue-styled-components'

const StyledAddress = styled.address`
  font-style: normal;
  
  .address__title {
    margin-bottom: 10px;
    font-size: 1rem;
    font-weight: ${props => props.theme.fontWeight.bold};
  }
  
  .address__item {
    display: block;
    color: #000000;
    font-family: 'Gilroy';
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.5rem;
  }
`

export {
  StyledAddress
}



// WEBPACK FOOTER //
// ./src/components/Address/StyledAddress.js